import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { API } from "@/App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setIsNewUser, setStoredToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          throw new Error('Session exchange failed');
        }

        const userData = await response.json();
        
        // Store token in localStorage for cross-domain support
        if (userData.session_token) {
          setStoredToken(userData.session_token);
        }
        
        // Track if new user for tutorial
        if (userData.is_new_user) {
          setIsNewUser(true);
          localStorage.setItem('kbn_show_tutorial', 'true');
        }
        
        setUser(userData);
        
        // Clear hash and navigate
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/home', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser, setIsNewUser, setStoredToken]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        <h2 className="text-2xl font-heading font-bold text-foreground mb-2">
          Setting things up...
        </h2>
        <p className="text-muted-foreground">Just a moment!</p>
      </div>
    </div>
  );
}
